import React, { Component } from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import { cartDispatcher, identityState, apttusDispatcher, combineDispatchers, popupDispatcher, combineStates, productState, superCodeDispatcher, messageDispatcher } from '../store';
import { IconButton } from '../components/actionPanel/IconButton';
import { translate } from '../services';
import { SaveToApttusComponent } from '../components/actionPanel/SaveToApttus';
import { getApttusCartInfo, getApttusCartInfoForReconfig, getConfiguration } from '../util';

export class ExportToApttusComponent extends Component {

  exportToApttusCart = () => {
    const { cart, prices, user, products } = this.props;
    this.props.saveToApttusCart( getApttusCartInfo( cart, prices, user, products ) )
      .then( response => {
        const data = response.data;
        const apttusUrl = this.props.user.properties["ApttusURL"];
        const show = this.showPopUp(data)
        if(show){
        this.props.setPopup(
          {
            title: `${translate('Save Status')}`,
            component: <SaveToApttusComponent user={user} response={ data } apttusUrl={ apttusUrl } deleteFromCart = {this.deleteFromCart} />,
            showHeader: true,
            keepOpen: false          
          } )
      }});
  }

  showPopUp = response => {
    const {user} = this.props;
    let showPopUp = false;
    let returnUrl = '';
    if(response){
      for ( let configResponse of response ) {
        if ( configResponse.paramApptusSaveError.toLowerCase().indexOf('success') < 0 ) {
          showPopUp = true;
        }
        else{
          returnUrl = (configResponse.paramApttusUrl == '' || configResponse.paramApttusUrl == null) ? user.properties["ApttusURL"] : configResponse.paramApttusUrl;
        }
      }
    }
    else{
      showPopUp = true;
    }
    if(!showPopUp){
      this.redirect(returnUrl);
    }

    return showPopUp;
  }
  redirect = apttusUrl => {
    const { cart } = this.props;
    this.deleteFromCart();
    window.close();
    window.location.href = apttusUrl;
  }

  deleteFromCart = () => {
    const { cart } = this.props;
    if(cart){
    for(const item of cart ){
      this.props.deleteFromCart( item );
    }
  }
  }

  exportToApttusCartReconfig = () => {
    const { prices, product, user, products, isReadyAssembled } = this.props;
    //Call api to create supercode
    if(isReadyAssembled){
      let tmpProduct = product;
      this.props.createSuperCode(getConfiguration( product, user ))
      .then(
        superCodeResponse => {
          if( superCodeResponse.data[0].errors && superCodeResponse.data[0].errors.length ){
            this.addMessage( "Some error occured while creating supercode", "error", 0 );
          }
          else{
            let message = '';
              superCodeResponse.data.forEach(item => {
                message = message == '' ? message + item.response: message + '\n' + item.response;
            })
            this.addMessage( message );
            //set supercode for main part
            const mainProductSupercode = superCodeResponse.data.filter(d=>d.variantId == tmpProduct.name).firstOrDefault().superCode;
            tmpProduct.superCode = mainProductSupercode;
            tmpProduct.code = mainProductSupercode + ' - ' + tmpProduct.code;
            //set supercode for fixed Part
            if(tmpProduct.additionalProducts.length > 0){
              if(superCodeResponse.data.filter(d=>d.variantId == tmpProduct.additionalProducts[0].code))
              {
                const fixedPartSupercode = superCodeResponse.data.filter(d=>d.variantId == tmpProduct.additionalProducts[0].name).firstOrDefault().superCode;
                tmpProduct.additionalProducts[0].superCode = fixedPartSupercode;
                tmpProduct.additionalProducts[0].code = fixedPartSupercode + '-' + tmpProduct.additionalProducts[0].superCode;
              }
            }

            this.props.saveToApttusCart( getApttusCartInfoForReconfig( prices, tmpProduct, user, products ) ).then( response => {
              const data = response.data;
              const apttusUrl = this.props.user.properties["ApttusURL"];
              const saveTitle = this.props.user.properties.CallingApp === ("Apttus" || "ELAPPTUS") ? 'Save To Apttus Status' : 'Save To BOL Status';
              const show = this.showPopUp(data);
              if(show){
              this.props.setPopup(
                {
                  title: saveTitle,
                  component: <SaveToApttusComponent  user={user} response={ data } apttusUrl={ apttusUrl } />,
                  showHeader: true,
                  keepOpen: false/* ,
                  onClose: this.redirect( apttusUrl ) */
                } );
              }
            } );
          }
        }
      )
      .catch(
        () => this.addMessage(translate( "Some error occured while creating or adding configuration to the cart", "error", 0 ))
      )
    }
    else{
    this.props.saveToApttusCart( getApttusCartInfoForReconfig( prices, product, user, products ) ).then( response => {
      const data = response.data;
      const apttusUrl = this.props.user.properties["ApttusURL"];
      const saveTitle = (this.props.user.properties.CallingApp === "Apttus" || this.props.user.properties.CallingApp === "ELAPPTUS") ? 'Save To Apttus Status' : 'Save To BOL Status';
      const show = this.showPopUp(data);
      if(show){
      this.props.setPopup(
        {
          title: saveTitle,
          component: <SaveToApttusComponent  user={user} response={ data } apttusUrl={ apttusUrl } />,
          showHeader: true,
          keepOpen: false/* ,
          onClose: this.redirect( apttusUrl ) */
        } );
      }
    } );
  }
  }

  hidePopup = () => this.props.hidePopup();
  addMessage = ( messageText, messageType= 'confirmation', timeout= 0 ) => {
    return this.props.addMessage( {  timeout: timeout, messageText: translate( messageText ), messageType: messageType  } )
  }
  render() {
    const reConfig = this.props["reConfig"];
    return <div className="apttus-status-window" >
     <h>{translate('Do you want to continue with save?')}</h>
      <div className="apttus-actions">
        <IconButton text={ translate( 'Cancel' ) } onClick={ this.hidePopup } />
        <IconButton
          className="blue-button" text={ translate( 'OK' ) }
          onClick={ reConfig ? this.exportToApttusCartReconfig : this.exportToApttusCart } />
      </div>
    </div>;
  }
}

ExportToApttusComponent.propTypes = {
  cartItems: PropTypes.arrayOf( PropTypes.shape( {} ) ),
  hidePopup: PropTypes.func.isRequired
};

export const ExportToApttus = connect(combineStates(identityState, productState), combineDispatchers( cartDispatcher, apttusDispatcher, popupDispatcher, superCodeDispatcher, messageDispatcher ) )( ExportToApttusComponent );